<template>
  <div
    v-show="isBannerEnabled"
    data-component-element-id="alertBanner"
    class="absolute top-[7px] w-[700px] 2xl:w-[1106px] inset-x-0 mx-auto z-998">
    <alert
      v-if="isBannerEnabled"
      :type="bannersState[selectedBannerType]?.type"
      :title="bannersState[selectedBannerType]?.title"
      :hideCloseBtn="bannersState[selectedBannerType]?.hideCloseBtn"
      @close="onBannerClosed">
      <template v-slot:message>
        <span v-html="bannersState[selectedBannerType]?.message"></span>
      </template>
    </alert>
  </div>
</template>

<script src="./alert-banner.js"></script>
